import React, { useState } from 'react';
import { Layout, Menu, ConfigProvider, Grid, Popover } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { AppAction } from '@store/actions';
import ButtonLoader from '@components/Button/ButtonLoader';

// import BasicModal from '../../components/Modal/BasicModal'

// ICONS IMPORT
import { RxDashboard } from 'react-icons/rx';
import { AiFillAlert } from 'react-icons/ai';
import { MdOutlineManageAccounts } from 'react-icons/md';
import { FaSitemap } from 'react-icons/fa6';
import { FaUserAlt } from 'react-icons/fa';
import { PiUsersThreeDuotone } from 'react-icons/pi';
import { FaCalendarAlt } from 'react-icons/fa';
import { FaFacebookMessenger } from 'react-icons/fa';
import { MdOutlineSecurity } from "react-icons/md";
import { FaUsersRays } from 'react-icons/fa6';
import { BsFillChatSquareTextFill } from "react-icons/bs";
import { IoSettingsSharp } from 'react-icons/io5';
import { TbRoute } from 'react-icons/tb';
import { MdOutlineAssignment } from 'react-icons/md';

import siteLogo from '@assets/images/logo-text-x.png';
import siteLogoCopy from '@assets/images/logo.svg';
import { IoLogOutSharp, IoNotificationsSharp, IoCalendarOutline, IoPersonOutline, IoLockClosedOutline } from 'react-icons/io5';
import { HiOutlineBellAlert } from 'react-icons/hi2';
import { Utils } from '@config';
import Colors from '@config/colors';
import useColors from '@hooks/useColors';
import { CloseCircleFilled } from '@ant-design/icons';
import { securityIssuesStaticPaths, workforceManagementStaticPaths } from '../../config/variables';
import { ShiftSchedulerAction } from '../../store/actions';

const AdminSideBar = () => {
    const { Sider } = Layout;
    const [logoutModal, setLogoutModal] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const [profileOpen, setProfileOpen] = useState(false);

    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const { loader, sidebarOpen, user } = useSelector(
        (state) => state?.AppReducer,
    );
    const currentLocation = location?.pathname;
    const { colorPrimary, colorSecondary } = useColors();
    const scrn = Grid.useBreakpoint();

    const logoutModalViewer = () => {
        setLogoutModal(true);
    };

    const logOut = () => {
        const payload = {
            from_everywhere: false,
        };
        dispatch(
            AppAction.Logout(payload, () => {
                // window.location.replace(Utils.getPublicOnboardingUrl());
                const companyData = JSON.parse(localStorage.getItem('companyData'));
                window.location.replace(Utils.getTenantLoginUrl(companyData?.url));
            }),
        );
    };

    const eventClickHandler = (info) => {
        // a rear case to handle whenever user visits on dashboard clearing the shifts record from previous
        // otherwise there is a duplication of data.
        if (info.key == 1) {
            dispatch(ShiftSchedulerAction.ClearShifts());
        }
    }

    return (
        <>
            <Sider
                trigger={null}
                collapsible
                collapsed={collapsed}
                className=""
                style={{
                    left: 0,
                    top: 0,
                    bottom: 0,
                    zIndex: 999,
                }}
                theme="light"
                breakpoint="lg"
                onCollapse={() => setCollapsed(!collapsed)}
                width={260}
            >
                <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
                    <div className="demo-logo-vertical" />
                    <ConfigProvider
                        theme={{
                            components: {
                                Menu: {
                                    // Background color of menu item when selected
                                    itemSelectedBg: '',
                                    // Color of selected menu item text
                                    itemSelectedColor: '',
                                    fontSize: collapsed ? 14 : 13,
                                },
                            },
                        }}
                    >
                        <Menu
                            theme="light"
                            mode="inline"
                            defaultSelectedKeys="1"
                            className="h-full"
                            style={{ flex: 1, padding: '0px 3px', overflowY: 'auto', overflowX: 'hidden' }}
                            onClick={(info) => eventClickHandler(info)}
                        >
                            {/* have to perform this inline stylng for bg and color , as on refresh of a page it will make the key = 1 and set the bg and color for dashboard whereas our current location is still pointing to where we are previously standing e.g user management */}
                            <>
                                {collapsed ? (
                                    <div className="flex flex-col items-center my-4">
                                        <div className={`rounded-full border border-gray-300 drop-shadow-md h-16 w-16 p-1`}>
                                            <Link to="/">
                                                <img
                                                    className="mx-auto py-0 object-cover w-full h-full rounded-full"
                                                    src={
                                                        user?.guardCompany?.logo?.[0]?.url ??
                                                        siteLogo
                                                    }
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="flex flex-col items-center my-4">
                                        <div className={`rounded-full border border-gray-300 drop-shadow-md h-20 w-20 p-1`}>
                                            <Link to="/">
                                                <img
                                                    className="mx-auto py-0 object-cover w-full h-full rounded-full"
                                                    src={
                                                        user?.guardCompany?.logo?.[0]?.url ??
                                                        siteLogo
                                                    }
                                                />
                                            </Link>
                                        </div>
                                        {user?.guardCompany?.name && (
                                            <p style={{ fontSize: '16px', fontWeight: '600', color: '#374151', marginTop: '6px', textAlign: 'center', lineHeight: '1.3', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                {user.guardCompany.name}
                                            </p>
                                        )}
                                    </div>
                                )}

                                <Menu.Item
                                    style={{
                                        background:
                                            currentLocation === '/'
                                                ? colorPrimary
                                                : '',
                                        color:
                                            currentLocation === '/'
                                                ? Colors.White
                                                : Colors.MenuItem,
                                    }}
                                    className="menu-item"
                                    key="1"
                                    icon={
                                        <div
                                            style={{
                                                padding: '3px',
                                                background:
                                                    currentLocation === '/'
                                                        ? '#2F3032'
                                                        : '#EEF4FF',
                                                borderRadius: '5px',
                                            }}
                                        >
                                            <RxDashboard
                                                style={{
                                                    paddingRight: collapsed
                                                        ? '0px'
                                                        : '',
                                                    paddingTop: collapsed
                                                        ? '0px'
                                                        : '',
                                                }}
                                                size={15}
                                                color={
                                                    currentLocation === '/'
                                                        ? Colors.White
                                                        : colorPrimary
                                                }
                                            />
                                        </div>
                                    }
                                >
                                    <Link to="/">Dashboard</Link>
                                </Menu.Item>

                                <Menu.Item
                                    style={{
                                        background:
                                            currentLocation === '/alert-management'
                                                ? colorPrimary
                                                : '',
                                        color:
                                            currentLocation === '/alert-management'
                                                ? Colors.White
                                                : Colors.MenuItem,
                                    }}
                                    className="menu-item"
                                    key="2"
                                    icon={
                                        <div
                                            style={{
                                                padding: '3px',
                                                background:
                                                    currentLocation === '/alert-management'
                                                        ? '#2F3032'
                                                        : '#EEF4FF',
                                                borderRadius: '5px',
                                            }}
                                        >
                                            <AiFillAlert
                                                style={{
                                                    paddingRight: collapsed
                                                        ? '0px'
                                                        : '',
                                                    paddingTop: collapsed
                                                        ? '0px'
                                                        : '',
                                                }}
                                                size={15}
                                                color={
                                                    currentLocation ===
                                                        '/alert-management'
                                                        ? Colors.White
                                                        : colorPrimary
                                                }
                                            />
                                        </div>
                                    }
                                >
                                    <Link to="/alert-management">
                                        Emergency Alert
                                    </Link>
                                </Menu.Item>

                                <Menu.Item
                                    style={{
                                        background:
                                            currentLocation === '/users-management'
                                                ? colorPrimary
                                                : '',
                                        color:
                                            currentLocation === '/users-management'
                                                ? Colors.White
                                                : Colors.MenuItem,
                                    }}
                                    className="menu-item"
                                    key="3"
                                    icon={
                                        <div
                                            style={{
                                                padding: '3px',
                                                background:
                                                    currentLocation ===
                                                        '/users-management'
                                                        ? '#2F3032'
                                                        : '#EEF4FF',
                                                borderRadius: '5px',
                                            }}
                                        >
                                            <MdOutlineManageAccounts
                                                style={{
                                                    paddingRight: collapsed
                                                        ? '0px'
                                                        : '',
                                                    paddingTop: collapsed
                                                        ? '0px'
                                                        : '',
                                                }}
                                                size={15}
                                                color={
                                                    currentLocation ===
                                                        '/users-management'
                                                        ? Colors.White
                                                        : colorPrimary
                                                }
                                            />
                                        </div>
                                    }
                                >
                                    <Link to="/users-management">
                                        User Management
                                    </Link>
                                </Menu.Item>

                                <Menu.Item
                                    style={{
                                        background:
                                            currentLocation === '/site-management' || currentLocation?.startsWith('/property-details/')
                                                ? colorPrimary
                                                : '',
                                        color:
                                            currentLocation === '/site-management' || currentLocation?.startsWith('/property-details/')
                                                ? Colors.White
                                                : Colors.MenuItem,
                                    }}
                                    className="menu-item"
                                    key="4"
                                    icon={
                                        <div
                                            style={{
                                                padding: '3px',
                                                background:
                                                    currentLocation === '/site-management' || currentLocation?.startsWith('/property-details/')
                                                        ? '#2F3032'
                                                        : '#EEF4FF',
                                                borderRadius: '5px',
                                            }}
                                        >
                                            <FaSitemap
                                                style={{
                                                    paddingRight: collapsed
                                                        ? '0px'
                                                        : '',
                                                    paddingTop: collapsed
                                                        ? '0px'
                                                        : '',
                                                }}
                                                size={15}
                                                color={
                                                    currentLocation === '/site-management' || currentLocation?.startsWith('/property-details/')
                                                        ? Colors.White
                                                        : colorPrimary
                                                }
                                            />
                                        </div>
                                    }
                                >
                                    <Link to="/site-management">
                                        Site Management
                                    </Link>
                                </Menu.Item>

                                <Menu.Item
                                    style={{
                                        background:
                                            currentLocation === '/client-support'
                                                ? colorPrimary
                                                : '',
                                        color:
                                            currentLocation === '/client-support'
                                                ? Colors.White
                                                : Colors.MenuItem,
                                    }}
                                    className="menu-item"
                                    key="5"
                                    icon={
                                        <div
                                            style={{
                                                padding: '3px',
                                                background:
                                                    currentLocation ===
                                                        '/client-support'
                                                        ? '#2F3032'
                                                        : '#EEF4FF',
                                                borderRadius: '5px',
                                            }}
                                        >
                                            <FaUserAlt
                                                style={{
                                                    paddingRight: collapsed
                                                        ? '0px'
                                                        : '',
                                                    paddingTop: collapsed
                                                        ? '0px'
                                                        : '',
                                                }}
                                                size={15}
                                                color={
                                                    currentLocation ===
                                                        '/client-support'
                                                        ? Colors.White
                                                        : colorPrimary
                                                }
                                            />
                                        </div>
                                    }
                                >
                                    <Link to="/client-support">
                                        Client Management
                                    </Link>
                                </Menu.Item>
                                <Menu.Item
                                    style={{
                                        background:
                                            workforceManagementStaticPaths.includes(currentLocation) || currentLocation?.startsWith('/workforce-management/TOR/detail/') || currentLocation?.startsWith('/workforce-management/DSR/detail/')
                                                ? colorPrimary
                                                : '',
                                        color:
                                            workforceManagementStaticPaths.includes(currentLocation) || currentLocation?.startsWith('/workforce-management/TOR/detail/') || currentLocation?.startsWith('/workforce-management/DSR/detail/')
                                                ? Colors.White
                                                : Colors.MenuItem,
                                    }}
                                    className="menu-item"
                                    key="6"
                                    icon={
                                        <div
                                            style={{
                                                padding: '3px',
                                                background:
                                                    workforceManagementStaticPaths.includes(currentLocation) || currentLocation?.startsWith('/workforce-management/TOR/detail/') || currentLocation?.startsWith('/workforce-management/DSR/detail/')
                                                        ? '#2F3032'
                                                        : '#EEF4FF',
                                                borderRadius: '5px',
                                            }}
                                        >
                                            <PiUsersThreeDuotone
                                                style={{
                                                    paddingRight: collapsed
                                                        ? '0px'
                                                        : '',
                                                    paddingTop: collapsed
                                                        ? '0px'
                                                        : '',
                                                }}
                                                size={20}
                                                color={
                                                    workforceManagementStaticPaths.includes(currentLocation) || currentLocation?.startsWith('/workforce-management/TOR/detail/') || currentLocation?.startsWith('/workforce-management/DSR/detail/')
                                                        ? Colors.White
                                                        : colorPrimary
                                                }
                                            />
                                        </div>
                                    }
                                >
                                    <Link to="/workforce-management">
                                        Workforce Management
                                    </Link>
                                </Menu.Item>
                                <Menu.Item
                                    style={{
                                        background:
                                            currentLocation ===
                                                '/attendance-management'
                                                ? colorPrimary
                                                : '',
                                        color:
                                            currentLocation ===
                                                '/attendance-management'
                                                ? Colors.White
                                                : Colors.MenuItem,
                                    }}
                                    className="menu-item"
                                    key="7"
                                    icon={
                                        <div
                                            style={{
                                                padding: '3px',
                                                background:
                                                    currentLocation ===
                                                        '/attendance-management'
                                                        ? '#2F3032'
                                                        : '#EEF4FF',
                                                borderRadius: '5px',
                                            }}
                                        >
                                            <FaCalendarAlt
                                                style={{
                                                    paddingRight: collapsed
                                                        ? '0px'
                                                        : '',
                                                    paddingTop: collapsed
                                                        ? '0px'
                                                        : '',
                                                }}
                                                size={15}
                                                color={
                                                    currentLocation ===
                                                        '/attendance-management'
                                                        ? Colors.White
                                                        : colorPrimary
                                                }
                                            />
                                        </div>
                                    }
                                >
                                    <Link to="/attendance-management">
                                        Attendance Management
                                    </Link>
                                </Menu.Item>
                                <Menu.Item
                                    style={{
                                        background:
                                            securityIssuesStaticPaths.includes(currentLocation) || currentLocation?.startsWith('/security-issues/manage-incidents/report/') || currentLocation?.startsWith('/security-issues/view-report')
                                                ? colorPrimary
                                                : '',
                                        color:
                                            securityIssuesStaticPaths.includes(currentLocation) || currentLocation?.startsWith('/security-issues/manage-incidents/report/') || currentLocation?.startsWith('/security-issues/view-report')
                                                ? Colors.White
                                                : Colors.MenuItem,
                                    }}
                                    className="menu-item"
                                    key="8"
                                    icon={
                                        <div
                                            style={{
                                                padding: '3px',
                                                background:
                                                    securityIssuesStaticPaths.includes(currentLocation) || currentLocation?.startsWith('/security-issues/manage-incidents/report/') || currentLocation?.startsWith('/security-issues/view-report')
                                                        ? '#2F3032'
                                                        : '#EEF4FF',
                                                borderRadius: '5px',
                                            }}
                                        >
                                            <MdOutlineSecurity
                                                style={{
                                                    paddingRight: collapsed
                                                        ? '0px'
                                                        : '',
                                                    paddingTop: collapsed
                                                        ? '0px'
                                                        : '',
                                                }}
                                                size={15}
                                                color={
                                                    securityIssuesStaticPaths.includes(currentLocation) || currentLocation?.startsWith('/security-issues/manage-incidents/report/') || currentLocation?.startsWith('/security-issues/view-report')
                                                        ? Colors.White
                                                        : colorPrimary
                                                }
                                            />
                                        </div>
                                    }
                                >
                                    <Link to="/security-issues">
                                        Security Issues
                                    </Link>
                                </Menu.Item>
                                <Menu.Item
                                    style={{
                                        background:
                                            currentLocation === '/connectivity-hub'
                                                ? colorPrimary
                                                : '',
                                        color:
                                            currentLocation === '/connectivity-hub'
                                                ? Colors.White
                                                : Colors.MenuItem,
                                    }}
                                    className="menu-item"
                                    key="9"
                                    icon={
                                        <div
                                            style={{
                                                padding: '3px',
                                                background:
                                                    currentLocation ===
                                                        '/connectivity-hub'
                                                        ? '#2F3032'
                                                        : '#EEF4FF',
                                                borderRadius: '5px',
                                            }}
                                        >
                                            <BsFillChatSquareTextFill
                                                style={{
                                                    paddingRight: collapsed
                                                        ? '0px'
                                                        : '',
                                                    paddingTop: collapsed
                                                        ? '0px'
                                                        : '',
                                                }}
                                                size={15}
                                                color={
                                                    currentLocation ===
                                                        '/connectivity-hub'
                                                        ? Colors.White
                                                        : colorPrimary
                                                }
                                            />
                                        </div>
                                    }
                                >
                                    <Link to="/connectivity-hub">
                                        Connectivity Hub
                                    </Link>
                                </Menu.Item>


                                {/* ── Patrol section ─────────────────────── */}
                                <Menu.Item
                                    style={{
                                        background: currentLocation === '/patrols' || currentLocation?.startsWith('/patrols/') ? colorPrimary : '',
                                        color: currentLocation === '/patrols' || currentLocation?.startsWith('/patrols/') ? Colors.White : Colors.MenuItem,
                                    }}
                                    className="menu-item"
                                    key="patrol-list"
                                    icon={
                                        <div style={{ padding: '3px', background: currentLocation === '/patrols' || currentLocation?.startsWith('/patrols/') ? '#2F3032' : '#EEF4FF', borderRadius: '5px' }}>
                                            <TbRoute size={15} color={currentLocation === '/patrols' || currentLocation?.startsWith('/patrols/') ? Colors.White : colorPrimary} />
                                        </div>
                                    }
                                >
                                    <Link to="/patrols">Patrols</Link>
                                </Menu.Item>

                                <Menu.Item
                                    style={{
                                        background: currentLocation === '/checkpoint-follow-ups' ? colorPrimary : '',
                                        color: currentLocation === '/checkpoint-follow-ups' ? Colors.White : Colors.MenuItem,
                                    }}
                                    className="menu-item"
                                    key="follow-ups"
                                    icon={
                                        <div style={{ padding: '3px', background: currentLocation === '/checkpoint-follow-ups' ? '#2F3032' : '#EEF4FF', borderRadius: '5px' }}>
                                            <MdOutlineAssignment size={15} color={currentLocation === '/checkpoint-follow-ups' ? Colors.White : colorPrimary} />
                                        </div>
                                    }
                                >
                                    <Link to="/checkpoint-follow-ups">Follow-ups</Link>
                                </Menu.Item>
                                <Menu.Item
                                    style={{
                                        background:
                                            currentLocation === '/setting'
                                                ? colorPrimary
                                                : '',
                                        color:
                                            currentLocation === '/setting'
                                                ? Colors.White
                                                : Colors.MenuItem,
                                    }}
                                    className="menu-item"
                                    key="10"
                                    icon={
                                        <div
                                            style={{
                                                padding: '3px',
                                                background:
                                                    currentLocation === '/setting'
                                                        ? '#2F3032'
                                                        : '#EEF4FF',
                                                borderRadius: '5px',
                                            }}
                                        >
                                            <IoSettingsSharp
                                                style={{
                                                    paddingRight: collapsed
                                                        ? '0px'
                                                        : '',
                                                    paddingTop: collapsed
                                                        ? '0px'
                                                        : '',
                                                }}
                                                size={15}
                                                color={
                                                    currentLocation === '/setting'
                                                        ? Colors.White
                                                        : colorPrimary
                                                }
                                            />
                                        </div>
                                    }
                                >
                                    <Link to="/setting">Setting</Link>
                                </Menu.Item>
                            </>
                        </Menu>
                    </ConfigProvider>

                    <div style={{ padding: '8px 10px 12px' }}>
                        <Popover
                            open={profileOpen}
                            onOpenChange={setProfileOpen}
                            placement="top"
                            trigger="click"
                            overlayInnerStyle={{ padding: 0, borderRadius: '12px', overflow: 'hidden', minWidth: '220px' }}
                            content={
                                <div>
                                    {/* User info header */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '14px 16px', borderBottom: '1px solid #f0f0f0' }}>
                                        <div style={{ flexShrink: 0, width: '38px', height: '38px', borderRadius: '8px', overflow: 'hidden', border: '1.5px solid #e5e7eb', background: '#f3f4f6' }}>
                                            <img src={user?.profileImg?.[0]?.url ?? siteLogo} alt="avatar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        </div>
                                        <div style={{ minWidth: 0 }}>
                                            <p style={{ margin: 0, fontSize: '13px', fontWeight: '600', color: '#111827', lineHeight: '1.4' }}>
                                                {[user?.firstName, user?.lastName].filter(Boolean).join(' ') || 'User'}
                                            </p>
                                            <p style={{ margin: 0, fontSize: '11px', color: '#6b7280', wordBreak: 'break-all' }}>{user?.email || ''}</p>
                                        </div>
                                    </div>
                                    {/* My Availability (if not client) */}
                                    {user?.userRole?.[0] !== 'client' && (
                                        <Link to="/MyAvailability" onClick={() => setProfileOpen(false)}>
                                            <div
                                                style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '11px 16px', fontSize: '13px', color: '#374151', cursor: 'pointer', transition: 'background 0.15s' }}
                                                onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'}
                                                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                                            >
                                                <IoCalendarOutline size={16} color="#6b7280" />
                                                <span>My Availability</span>
                                            </div>
                                        </Link>
                                    )}
                                    {/* Edit Profile (if not client) */}
                                    {user?.userRole?.[0] !== 'client' && (
                                        <Link to="/EditProfile" onClick={() => setProfileOpen(false)}>
                                            <div
                                                style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '11px 16px', fontSize: '13px', color: '#374151', cursor: 'pointer', transition: 'background 0.15s' }}
                                                onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'}
                                                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                                            >
                                                <IoPersonOutline size={16} color="#6b7280" />
                                                <span>Edit Profile</span>
                                            </div>
                                        </Link>
                                    )}
                                    {/* Change Password */}
                                    <Link to="/ChangePassword" onClick={() => setProfileOpen(false)}>
                                        <div
                                            style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '11px 16px', fontSize: '13px', color: '#374151', cursor: 'pointer', transition: 'background 0.15s' }}
                                            onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'}
                                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                                        >
                                            <IoLockClosedOutline size={16} color="#6b7280" />
                                            <span>Change Password</span>
                                        </div>
                                    </Link>
                                    {/* Notifications */}
                                    <Link to="/Notifications" onClick={() => setProfileOpen(false)}>
                                        <div
                                            style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '11px 16px', fontSize: '13px', color: '#374151', cursor: 'pointer', transition: 'background 0.15s' }}
                                            onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'}
                                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                                        >
                                            <HiOutlineBellAlert size={16} color="#6b7280" />
                                            <span>Notifications</span>
                                        </div>
                                    </Link>
                                    <div style={{ height: '1px', background: '#f0f0f0' }} />
                                    {/* Sign out */}
                                    <div
                                        onClick={() => { setProfileOpen(false); logOut(); }}
                                        style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '11px 16px', fontSize: '13px', color: '#374151', cursor: 'pointer', transition: 'background 0.15s' }}
                                        onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'}
                                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                                    >
                                        <IoLogOutSharp size={16} color="#6b7280" />
                                        <span>Sign out</span>
                                    </div>
                                </div>
                            }
                        >
                            {/* Trigger card */}
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    background: colorPrimary,
                                    borderRadius: '12px',
                                    padding: collapsed ? '8px 6px' : '8px 10px',
                                    justifyContent: collapsed ? 'center' : 'space-between',
                                    cursor: 'pointer',
                                    width: '100%',
                                    overflow: 'hidden',
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0, flex: 1 }}>
                                    <div style={{ flexShrink: 0, width: '36px', height: '36px', borderRadius: '8px', overflow: 'hidden', border: '1.5px solid rgba(255,255,255,0.4)', background: 'rgba(255,255,255,0.2)' }}>
                                        <img
                                            src={user?.profileImg?.[0]?.url ?? siteLogo}
                                            alt="avatar"
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        />
                                    </div>
                                    {!collapsed && (
                                        <div style={{ minWidth: 0, flex: 1 }}>
                                            <p style={{ margin: 0, fontSize: '12px', fontWeight: '600', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {[user?.firstName, user?.lastName].filter(Boolean).join(' ') || 'User'}
                                            </p>
                                            <p style={{ margin: 0, fontSize: '11px', color: 'rgba(255,255,255,0.75)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {user?.email || ''}
                                            </p>
                                        </div>
                                    )}
                                </div>
                                {!collapsed && (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                                        <HiOutlineBellAlert size={16} color="#fff" onClick={(e) => { e.stopPropagation(); navigate('/Notifications'); setProfileOpen(false); }} />
                                        <span style={{ color: '#fff', fontSize: '10px' }}>
                                            {profileOpen ? '▼' : '▲'}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </Popover>
                    </div>
                </div>
            </Sider>

            {/* {

                <BasicModal
                    centered={'centered'}
                    width={'300px'}
                    modalType={'basicModal'}
                    text='Are you sure, you want to logout ?'
                    descriptionStyle={{ textAlign: 'center', fontSize: '1.3rem', fontWeight: '500', margin: '10px' }}
                    isModalOpen={logoutModal}
                    isFooter={true}
                    leftButtonText='yes'
                    rightButtonText="no"
                    rightButtonStyle={{ backgroundColor: 'black', color: 'white' }}
                    leftButtonStyle={{ backgroundColor: 'green', color: 'white' }}
                    onClickLeft={logOut} onClickRight={() => setLogoutModal(false)}
                    onCancel={() => setLogoutModal(false)} />
            } */}
        </>
    );
};

export default AdminSideBar;
